/**
 * @flow
 * @relayHash d033c10354953b7528f561158987cd26
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type H1IssueTable_project$ref = any;
export type onpage_OnPageCategory_H1IssueTable_QueryVariables = {|
  host: string
|};
export type onpage_OnPageCategory_H1IssueTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: H1IssueTable_project$ref
  |}
|};
export type onpage_OnPageCategory_H1IssueTable_Query = {|
  variables: onpage_OnPageCategory_H1IssueTable_QueryVariables,
  response: onpage_OnPageCategory_H1IssueTable_QueryResponse,
|};
*/


/*
query onpage_OnPageCategory_H1IssueTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...H1IssueTable_project
    id
  }
}

fragment H1IssueTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesH1Issues(h1: {operator: AND, values: []}, url: {operator: AND, values: []}) {
          type
          severity
          count
        }
        h1Issues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, h1: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...H1IssueRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment H1IssueRow_issue on H1Issue {
  id
  type
  severity
  h1s
  url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "h1",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "url",
  "value": v3,
  "type": "TextFilters"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "onpage_OnPageCategory_H1IssueTable_Query",
  "id": null,
  "text": "query onpage_OnPageCategory_H1IssueTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...H1IssueTable_project\n    id\n  }\n}\n\nfragment H1IssueTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesH1Issues(h1: {operator: AND, values: []}, url: {operator: AND, values: []}) {\n          type\n          severity\n          count\n        }\n        h1Issues(offset: 0, limit: 20, typeFilters: [], url: {operator: AND, values: []}, h1: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...H1IssueRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment H1IssueRow_issue on H1Issue {\n  id\n  type\n  severity\n  h1s\n  url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "onpage_OnPageCategory_H1IssueTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "H1IssueTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "onpage_OnPageCategory_H1IssueTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesH1Issues",
                        "storageKey": "countTypesH1Issues(h1:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v6,
                          v7,
                          v8
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "h1Issues",
                        "storageKey": "h1Issues(h1:{\"operator\":\"AND\",\"values\":[]},limit:20,offset:0,typeFilters:[],url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          {
                            "kind": "Literal",
                            "name": "typeFilters",
                            "value": [],
                            "type": "[String]"
                          },
                          v5
                        ],
                        "concreteType": "H1IssuesConnection",
                        "plural": false,
                        "selections": [
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "H1IssuesEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "H1Issue",
                                "plural": false,
                                "selections": [
                                  v9,
                                  v6,
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "h1s",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v9
                    ]
                  }
                ]
              }
            ]
          },
          v9
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37fe29b2c4a7afcb03cdc548ce5ec335';
module.exports = node;
